import { render, staticRenderFns } from "./ReviewsList.vue?vue&type=template&id=456a5613&"
import script from "./ReviewsList.vue?vue&type=script&lang=js&"
export * from "./ReviewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports